export const PLATFORMS = [
  { label: 'Instagram', value: 'instagram' },
  { label: 'TikTok', value: 'tiktok' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'X', value: 'x' },
] as const;

export const COMMERCIAL_TYPES = [
  { label: 'Paid', value: 'influencers_p' },
  { label: 'Contra', value: 'influencers_c' },
  { label: 'Organic', value: 'influencers_o' },
] as const;

export type Platform = (typeof PLATFORMS)[number]['value'];
export type CommercialType = (typeof COMMERCIAL_TYPES)[number]['value'];
